var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-img',{attrs:{"src":this.$store.state.modules.options.app_background
        ? this.$store.state.modules.options.app_background
        : '/img/background-login.jpg',"gradient":"to top, rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)","min-height":"100%"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }